/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Clipboard_UnavailableInputs */

const en_image_inspector_clipboard_unavailable = /** @type {(inputs: Image_Inspector_Clipboard_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clipboard unavailable`)
};

const ar_image_inspector_clipboard_unavailable = /** @type {(inputs: Image_Inspector_Clipboard_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحافظة غير متاحة`)
};

const bn_image_inspector_clipboard_unavailable = /** @type {(inputs: Image_Inspector_Clipboard_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্লিপবোর্ড পাওয়া যাচ্ছে না`)
};

const de_image_inspector_clipboard_unavailable = /** @type {(inputs: Image_Inspector_Clipboard_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwischenablage nicht verfügbar`)
};

const es_image_inspector_clipboard_unavailable = /** @type {(inputs: Image_Inspector_Clipboard_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portapapeles no disponible`)
};

const fr_image_inspector_clipboard_unavailable = /** @type {(inputs: Image_Inspector_Clipboard_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presse-papiers indisponible`)
};

const pt_image_inspector_clipboard_unavailable = /** @type {(inputs: Image_Inspector_Clipboard_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Área de transferência indisponível`)
};

const zh_image_inspector_clipboard_unavailable = /** @type {(inputs: Image_Inspector_Clipboard_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剪贴板不可用`)
};

const tr_image_inspector_clipboard_unavailable = /** @type {(inputs: Image_Inspector_Clipboard_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pano kullanılamıyor`)
};

const ru_image_inspector_clipboard_unavailable = /** @type {(inputs: Image_Inspector_Clipboard_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Буфер обмена недоступен`)
};

const pl_image_inspector_clipboard_unavailable = /** @type {(inputs: Image_Inspector_Clipboard_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schowek niedostępny`)
};

/**
* | output |
* | --- |
* | "Clipboard unavailable" |
*
* @param {Image_Inspector_Clipboard_UnavailableInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_clipboard_unavailable = /** @type {((inputs?: Image_Inspector_Clipboard_UnavailableInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Clipboard_UnavailableInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_clipboard_unavailable(inputs)
	if (locale === "bn") return bn_image_inspector_clipboard_unavailable(inputs)
	if (locale === "de") return de_image_inspector_clipboard_unavailable(inputs)
	if (locale === "es") return es_image_inspector_clipboard_unavailable(inputs)
	if (locale === "fr") return fr_image_inspector_clipboard_unavailable(inputs)
	if (locale === "pt") return pt_image_inspector_clipboard_unavailable(inputs)
	if (locale === "zh") return zh_image_inspector_clipboard_unavailable(inputs)
	if (locale === "tr") return tr_image_inspector_clipboard_unavailable(inputs)
	if (locale === "ru") return ru_image_inspector_clipboard_unavailable(inputs)
	if (locale === "pl") return pl_image_inspector_clipboard_unavailable(inputs)
	return en_image_inspector_clipboard_unavailable(inputs)
});